import React from 'react';
import Corners from '../ui/Corners';
import Reveal from '../ui/Reveal';
import SectionHeader from '../ui/SectionHeader';
import './Learning.css';

const EDUCATION = [
  {
    id: 'dogus',
    icon: '🎓',
    period: '2022 – 2026',
    title: 'Doğuş University',
    sub: 'B.Sc. in Computer Engineering · English, 100% scholarship',
    description: 'Completed a Computer Engineering degree on a full scholarship. Focus on artificial intelligence, machine learning, and software development.',
  },
  {
    id: 'yucel',
    icon: '🏫',
    period: '2020',
    title: 'Yücel Boru Fen Lisesi',
    sub: 'Science high school',
    description: 'Graduated from Science High School with a strong foundation in mathematics and sciences.',
  },
  {
    id: 'tlc',
    flag: { src: 'https://flagcdn.com/w80/es.png', alt: 'Spain' },
    period: 'Jun – Aug 2018',
    title: 'TLCDénia Escuela de Español',
    sub: 'Spanish language education · Denia, Spain',
    description: 'Intensive Spanish language programme in Spain, reaching B1 proficiency.',
  },
  {
    id: 'kaplan',
    flag: { src: 'https://flagcdn.com/w80/gb.png', alt: 'United Kingdom' },
    period: 'Jun – Jul 2019',
    title: 'Kaplan International',
    sub: 'Advanced English language education · Oxford, UK',
    description: 'Advanced English language programme in Oxford, reaching C1 proficiency.',
  },
];

const CERTIFICATES = [
  {
    id: 'miuul-pm',
    icon: '🧠',
    period: 'March 2026',
    title: 'Product Management & Ownership Specialisation',
    sub: 'Miuul',
    description: 'Scrum product ownership, backlog management, UI & UX, data-driven product development, and product metrics — end-to-end product lifecycle management with a focus on turning data into actionable product decisions.',
  },
  {
    id: 'miuul-ds',
    icon: '📊',
    period: 'Sep – Dec 2025',
    title: 'Data Science Bootcamp',
    sub: 'Miuul',
    description: 'Python, CRM analytics, recommendation systems, feature engineering, ML algorithms, and MS SQL. Hands-on work on real-world datasets with a focus on customer analytics and predictive modeling.',
  },
  {
    id: 'coderspace',
    icon: '☀️',
    period: 'July 2025',
    title: 'Data Science & AI Summer School',
    sub: 'Coderspace',
    description: '48-hour programme covering Python, data analysis and visualization, ML, deep learning, and GenAI, with corporate sessions from İş Bankası, Trendyol, Koç Digital and ING Hubs.',
  },
];

const Column = ({ heading, items }) => (
  <div className="learn-col">
    <Reveal as="h3" className="learn-col-title mono" y={10}>{heading}</Reveal>
    <ul className="learn-list">
      {items.map((item, i) => (
        <Reveal as="li" key={item.id} delay={i * 0.06} className="learn-item has-corners">
          <span className="learn-badge" aria-hidden={item.flag ? undefined : 'true'}>
            {item.flag
              ? <img src={item.flag.src} alt={item.flag.alt} width="28" height="20" loading="lazy" />
              : item.icon}
          </span>
          <div>
            <span className="learn-period mono">{item.period}</span>
            <h4 className="learn-title">{item.title}</h4>
            <p className="learn-sub">{item.sub}</p>
            <p className="learn-desc">{item.description}</p>
          </div>
          <Corners />
        </Reveal>
      ))}
    </ul>
  </div>
);

const Learning = () => (
  <section id="learning" className="section learn">
    <div className="container">
      <SectionHeader eyebrow="learning" title="Degrees and training." />
      <div className="learn-grid">
        <Column heading="Education" items={EDUCATION} />
        <Column heading="Certificates" items={CERTIFICATES} />
      </div>
    </div>
  </section>
);

export default Learning;
